import {OutlinedInput} from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import SearchBar from 'components/Forms/SearchBar'
import {useLocation} from 'react-router-dom'
import useToolbarStyles, {
  useOutlinedInputStyles,
} from 'components/Table/useTableToolbarStyles'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {getQueryFromUrl} from 'helpers/commonHelper'
/* eslint-disable */
const SEARCH_SELECT_ITEMS: SelectItem<KeyOfAnalysisSearchKind>[] = [
  {label: 'IIndex', value: 'INDEX'},
  {label: 'IPatientName', value: 'NAME'},
  // {label: 'IECEO', value: 'ECEO'},
  {label: 'IFileName', value: 'FILE_NAME'},
]

interface SelectAnalysisSearchProps {
  onSearch: (params: AnalysisSearchKind) => void
  options?: SelectItem<KeyOfAnalysisSearchKind>[]
}

export default function AnalysisSearch({
  onSearch,
  options = SEARCH_SELECT_ITEMS,
}: SelectAnalysisSearchProps) {
  const location = useLocation()
  const classes = useToolbarStyles()
  const outlinedInputClasses = useOutlinedInputStyles()

  const {t} = useTranslation()
  const currentDate = new Date()

  const [searchCondition, setSearchCondition] =
    useState<KeyOfAnalysisSearchKind>('NAME')
  const [searchKeyword, setSearchKeyword] = useState('')
  const [measureDate, setMeasureDate] = useState(currentDate)

  const handleSearchChanged = (event: React.ChangeEvent<{value: unknown}>) =>
    setSearchCondition(event.target.value as KeyOfAnalysisSearchKind)

  const handleMeasureDateChanged = (date: Date | null) => {
    if (date) setMeasureDate(date)
    console.log('measureDate:', date)
  }

  /** Set default value for search condition if it is stored in url */
  useEffect(() => {
    const searchParams = getQueryFromUrl(location.search)
    if (searchParams?.search && searchParams.search.searchName) {
      setSearchCondition(searchParams.search.searchName)
    }
  }, [])

  const getSearch = (): AnalysisSearchKind => {
    if (searchCondition === 'INDEX') {
      return {
        searchName: searchCondition,
        searchValue: Number.parseInt(searchKeyword, 10),
      }
    }
    if (searchCondition === 'ECEO') {
      return {
        searchName: searchCondition,
        searchValue: searchKeyword as ECEOSearch['searchValue'],
      }
    }
    return {
      searchName: searchCondition,
      searchValue: searchKeyword,
    }
  }

  const handleSearch = () => {
    console.log(getSearch())
    const newSearch = getSearch()
    onSearch(newSearch)
  }

  const handleValue = (value: any) => {
    setSearchKeyword(value)
  }

  return (
    <div className={classes.searchContainer}>
      <FormControl variant='outlined'>
        <Select
          value={searchCondition}
          onChange={handleSearchChanged}
          className={classes.searchSelect}
          input={
            <OutlinedInput
              name='age'
              id='outlined-age-simple'
              classes={outlinedInputClasses}
            />
          }
        >
          {options.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {t(item.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <SearchBar
        onChangeValue={handleValue}
        onSearchEvent={handleSearch}
        disabledValue={false}
      />
    </div>
  )
}
